<template>
  <div>
    <loading-container v-if="loading"></loading-container>

    <div v-else class="container">
      <div class="row">
        <div class="col-xs-6">
          <help-text>
            <h3>
              Edit Mailing List
            </h3>

            <p>
              Edit the details of the mailing list.
            </p>
          </help-text>
        </div>

        <div class="col-xs-18">
          <div class="panel panel-default">
            <div class="panel-body">
              <form @submit.prevent="submit" class="form-horizontal">
                <StaticFormGroup
                    :value="data.name"
                    label="Name"
                    help-text="The name of the mailing list."
                ></StaticFormGroup>

                <SelectFormGroup
                    v-model="data.reference"
                    name="reference"
                    label="Reference"
                    help-text="The external reference to the mailing list."
                    :error="getError('reference')"
                    :options="externalMailingListOptions"
                ></SelectFormGroup>

                <hr>

                <SubmitFormGroup button-class="btn-black"></SubmitFormGroup>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import HelpText from '@/components/HelpText'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import StaticFormGroup from '@/vendor/forms/FormGroups/Horizontal/Static'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'

export default {
  components: {HelpText, LoadingContainer, SelectFormGroup, StaticFormGroup, SubmitFormGroup},

  mixins: [Errors],

  model: {
    prop: 'portal',
    event: 'portal-updated'
  },

  props: {
    portal: {
      required: true
    },

    mailingListId: {
      required: true
    }
  },

  data() {
    return {
      data: {},
      externalMailingLists: null,

      loading: true
    }
  },

  mounted() {
    Promise.all([
      http.get('/api/v2/mailing-lists/'+ this.mailingListId),
      http.get('/api/v2/external/mailing-lists')
    ]).then(responses=> {
      this.data = responses[0].data.data.attributes

      this.externalMailingLists = responses[1].data.data

      this.loading = false
    })
  },

  computed: {
    externalMailingListOptions() {
      return this.externalMailingLists.map(externalMailingList => {
        return {
          value: externalMailingList.id,
          label: externalMailingList.attributes.name
        }
      })
    }
  },

  methods: {
    submit() {
      http.put('/api/v2/mailing-lists/' + this.mailingListId, this.data)
          .then(() => {
            notify.success('The mailing list was saved')

            this.$router.push('/portals/' + this.portal.id + '/mailing-lists')
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
